import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SupervisorLayout from '../../components/SupervisorLayout';
import { listSupervisedBanks } from '../../api/supervisor';
import './SupervisorBanquePage.css';

// Variante superviseur (2026-09-17) de pages/parametres/BanquePage.jsx —
// recherche parmi SES banks seulement (listSupervisedBanks(), filtre client-side
// comme les modals Supervisor*SearchModal). Pas de bouton "New" : un bank nait
// de l'approbation d'un device par le superadmin, meme regle que cote company.
const SupervisorBanquePage = () => {
  const [allBanks, setAllBanks] = useState([]);
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    listSupervisedBanks()
      .then((data) => { setAllBanks(data); setResults(data); })
      .catch(() => setError('Impossible de charger les banks.'))
      .finally(() => setLoading(false));
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    const q = query.toLowerCase();
    setResults(
      allBanks.filter((b) => b.name.toLowerCase().includes(q) || (b.username || '').toLowerCase().includes(q))
    );
  };

  return (
    <SupervisorLayout>
      <p className="svbq-breadcrumb">
        Ruta : <Link to="/supervisor/dashboard" className="svbq-link">Menu</Link>
        {' >> '}
        <Link to="/supervisor/parametres" className="svbq-link">Parametres</Link>
        {' >> '}
        <span className="svbq-current">Banque</span>
      </p>

      <div className="svbq-card">
        <div className="svbq-card-header">
          <span className="svbq-card-title">Bank</span>
        </div>
        <div className="svbq-card-body">
          <button
            type="button"
            className="svbq-new-btn"
            disabled
            title="Un bank se cree via la validation d'un device par le Grand Admin."
          >
            New
          </button>

          <form onSubmit={handleSearch} className="svbq-search-row">
            <input
              className="svbq-search-input"
              type="text"
              placeholder="Username ou Name"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <button type="submit" className="svbq-search-btn">Search</button>
          </form>

          {error && <p className="svbq-error">{error}</p>}
          {loading ? (
            <p>Chargement...</p>
          ) : (
            <table className="svbq-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Username</th>
                  <th>Name</th>
                  <th>Group</th>
                  <th>Address</th>
                  <th>Telephone</th>
                </tr>
              </thead>
              <tbody>
                {results.map((bank) => (
                  <tr
                    key={bank.id}
                    className="svbq-row"
                    onClick={() => navigate(`/supervisor/banque/${bank.id}`)}
                  >
                    <td>{bank.seq}</td>
                    <td>{bank.username || '—'}</td>
                    <td>{bank.name}</td>
                    <td>{bank.group_name || ''}</td>
                    <td>{bank.address}</td>
                    <td>{bank.phone || '—'}</td>
                  </tr>
                ))}
                {results.length === 0 && (
                  <tr><td colSpan={6} className="svbq-empty">Aucune banque trouvée.</td></tr>
                )}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </SupervisorLayout>
  );
};

export default SupervisorBanquePage;
